__turbopack_context__.v({
  "card-preset-actions": "page-module-scss-module__buUe0W__card-preset-actions",
  "card-preset-container": "page-module-scss-module__buUe0W__card-preset-container",
  "lock-btn": "page-module-scss-module__buUe0W__lock-btn",
  "lock-btn-border-fade-in": "page-module-scss-module__buUe0W__lock-btn-border-fade-in",
});
